import { SpiSdk } from './types'
import { useSentry } from 'banquet-runtime-modules'
import { useEffect } from 'react'

declare global {
  interface Window {
    Toast: SpiSdk
  }
}

export const useSpiSdk = () => {
  const { captureException } = useSentry()

  useEffect(() => {
    if (!window.Toast) {
      captureException(new Error('SPI - SDK not loaded when useSpiSdk called'))
    }
  }, [])

  return window.Toast
}
